import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';
import { useFormikContext } from 'formik';

interface FormData {
    numberOfWaitingPeriodDays: string;
}

export const FirstWaitingPeriodMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward }] = navigator;
    const { setFieldValue, values } = useFormikContext<FormData>();

    const handleContinue = () => {
        setFieldValue('waitingPeriodMessageOpen', false);
        setFieldValue('waitingPeriodAnswerGiven', true);
    };

    const handleQuit = () => {
        setFieldValue('waitingPeriodMessageOpen', false);
        setFieldValue('resetProcess', true);
    };

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    height: 300,
                    paddingTop: '15px',
                    textAlign: 'center',
                }}
            >
                <p>{translations.waitingPeriod.TITLE}</p>
                <p>{translations.waitingPeriod.INFO}</p>
                <p
                    style={{ fontSize: '1.3rem', fontWeight: 'bold' }}
                >{`${values.numberOfWaitingPeriodDays} ${translations.waitingPeriod.DAYS_TEXT}`}</p>
                <p>{translations.waitingPeriod.FOOTER}</p>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <Button onClickHandler={handleQuit} label={common.QUIT} />
                <Button onClickHandler={handleContinue} label={common.CONTINUE} />
            </Box>
        </>
    );
};
